import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { HttpApiService } from '@recruitee/http';
import { CountryRegion } from '@recruitee/http-types';

@Injectable({ providedIn: 'root' })
export class RegionsHttpClient {
  constructor(protected httpApi: HttpApiService) {}

  public fetchRegions(countryCode: string): Observable<CountryRegion[]> {
    return this.httpApi
      .get(`/regions`, { country_code: countryCode })
      .pipe(map(data => data.regions));
  }
}
